import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  findAllVehicleModelPageble,
  createVehicleModel,
  deleteVehicleModel,
  updateVehicleModel,
  deleteErrorVehicleModel,
} from '../../actions/vehicleModel';
import { findAllBrand } from '../../actions/brand';
import VehicleModelTable from '../VehicleModel/VehicleModelTable';
import { HeaderTable } from '../../enums/VehicleModelEnums';
import { TableContainer } from '../Reusable/TableContainer';
import ModalForAddVehicleModel from '../VehicleModel/ModalForAddVehicleModel';
import brand from '../../reducers/brand';

const VehicleModelList = () => {
  const dispatch = useDispatch();
  const vehicleModelReducer = useSelector((state) => state.vehicleModel);
const brandReducer=useSelector((state) => state.brand);
  const [show, setShow] = useState(false);

  const showModal = () => {
    setShow(true);
  };

  const clearValidationErrors = () => {
    dispatch(deleteErrorVehicleModel());
  };

  const handlePreviewClose = () => {
    setShow(false);
    clearValidationErrors();
  };

  const handleAdd = (vehicleModel) => {
    dispatch(createVehicleModel(vehicleModel, handlePreviewClose));
  };

  return (
    <>
      <TableContainer
        cardTitle={HeaderTable.titleForVehicleModelTable}
        showModal={showModal}
      >
        <VehicleModelTable
          dispatch={dispatch}
          vehicleModelReducer={vehicleModelReducer}
          findAllVehicleModelPageble={findAllVehicleModelPageble}
          updateVehicleModel={updateVehicleModel}
          deleteVehicleModel={deleteVehicleModel}
          clearValidationErrors={clearValidationErrors}
        brandReducer={brandReducer}
        />
      </TableContainer>
      {show && (
        <ModalForAddVehicleModel
          vehicleModelReducer={vehicleModelReducer}
          handleAdd={handleAdd}
          handleClose={handlePreviewClose}
          show={show}
          brandReducer={brandReducer}
        />
      )}
    </>
  );
};

export default VehicleModelList;
